import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'creditCardNumber' })
export class CreditCardNumberPipe implements PipeTransform {
  constructor() { }

  transform(value: any, last4: boolean = false) {
    if (typeof value === 'string') {
      let cardNumber = value.replace(' ', '').replace('-', '');
      if (cardNumber.length === 16) {
        return (last4 ? '' : '**** **** **** ') + value.substr(12);
      }
    }

    return value;
  }
}
